import React, { useEffect, useState } from 'react';
import { TableCell, TableRow, Fab, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { motion, AnimatePresence } from 'framer-motion';
import TableView from "./util/TableView";
import ReceiverDetailDialog from "./dialog/ReceiverDetailDialog";
import StringArrayList from "./util/StringArrayList";
import Moment from "react-moment";
import { ModuleHeader } from "../../components/composed";
import { Badge } from "../../components/primitives";
import { FadeIn } from "../../components/motion";

export default function ReceiverView(props) {
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogReceiver, setDialogReceiver] = useState({
    id: "",
    name: "",
    alternativeName: "",
    city: "",
    country: "",
    startDate: "",
    emails: [
      "",
    ]
  });

  useEffect(() => {
    props.setShowSearch(true);
  }, []);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const tableHeader =
    <TableRow>
      <TableCell>Id</TableCell>
      <TableCell>Name</TableCell>
      <TableCell>EPAM Email</TableCell>
      <TableCell>Emails</TableCell>
      <TableCell>Location</TableCell>
      <TableCell>Start Date</TableCell>
      <TableCell>Active</TableCell>
    </TableRow>;

  const tableRows = (row) =>
    <TableRow
      sx={{ cursor: 'pointer' }}
      key={row.id}
      onClick={() => {
        setDialogReceiver(row);
        setDialogOpen(true);
      }}
    >
      <TableCell>{row.id}</TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell>{row.epamEmail}</TableCell>
      <TableCell><StringArrayList strings={row.emails} /></TableCell>
      <TableCell>{row.city}, {row.country}</TableCell>
      <TableCell>
        {row.startDate && <Moment date={row.startDate} format="DD/MM/YYYY" />}
      </TableCell>
      <TableCell>
        <AnimatePresence mode="wait">
          <motion.div
            key={row.active ? 'active' : 'inactive'}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30,
            }}
            style={{ display: 'inline-block' }}
          >
            <Badge
              variant={row.active ? 'success' : 'neutral'}
              size="small"
            >
              {row.active ? 'Active' : 'Inactive'}
            </Badge>
          </motion.div>
        </AnimatePresence>
      </TableCell>
    </TableRow>;


  return (
    <FadeIn>
      <ModuleHeader
        title="Receivers"
        subtitle="Manage email recipients and their details"
        moduleColor={theme.palette.email?.main || theme.palette.info.main}
      />

      <ReceiverDetailDialog
        component={'span'}
        open={dialogOpen}
        handleClose={handleDialogClose}
        receiver={dialogReceiver}
        {...props}
      />
      <TableView
        fetchUrl={"receiver/all"}
        tableHeader={tableHeader}
        tableRows={tableRows}
        searchValue={props.searchValue}
        data={data}
        setData={setData}
        {...props}
      />
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          type: 'spring',
          stiffness: 260,
          damping: 20,
          delay: 0.4,
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        style={{
          position: 'fixed',
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        }}
      >
        <Fab
          color="secondary"
          aria-label="add"
          onClick={() => {
            setDialogReceiver(null);
            setDialogOpen(true);
          }}
        >
          <AddIcon />
        </Fab>
      </motion.div>
    </FadeIn>
  );
}
